import { useApp } from '@/context/AppContext';

const ROLES = ['Owner', 'Senior Tech', 'Technician', 'Trainee', 'Office'];
const COLORS = [
  { value: 'var(--cyan)',   label: 'Cyan' },
  { value: 'var(--violet)', label: 'Violet' },
  { value: 'var(--amber)',  label: 'Amber' },
  { value: 'var(--teal)',   label: 'Teal' },
  { value: 'var(--rose)',   label: 'Rose' },
];

export default function TechnicianModal({ data }) {
  const { addTechnician, updateTechnician, deleteTechnician, closeModal } = useApp();
  const existing = data?.tech || null;
  const isEdit = !!existing;

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const formData = Object.fromEntries(fd);
    const payload = {
      name:  formData.name,
      email: formData.email,
      phone: formData.phone,
      role:  formData.role,
      color: formData.color,
    };
    if (isEdit) {
      updateTechnician(existing.id, payload);
    } else {
      addTechnician(payload);
    }
    closeModal();
  };

  const handleDelete = () => {
    if (!existing) return;
    if (!confirm(`Remove ${existing.name} from team?`)) return;
    deleteTechnician(existing.id);
    closeModal();
  };

  return (
    <div className="modal">
      <div className="modal-head">
        <span className="modal-title">{isEdit ? 'Edit Technician' : 'Add New Technician'}</span>
        <button className="btn btn-ghost btn-sm" onClick={closeModal}>✕</button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Full Name *</label>
            <input name="name" placeholder="Jane Smith" required defaultValue={existing?.name || ''} />
          </div>
          <div className="form-row">
            <div className="field">
              <label>Phone</label>
              <input name="phone" placeholder="(555) 000-0000" defaultValue={existing?.phone || ''} />
            </div>
            <div className="field">
              <label>Email</label>
              <input name="email" type="email" placeholder="jane@company.com" defaultValue={existing?.email || ''} />
            </div>
          </div>
          <div className="form-row">
            <div className="field">
              <label>Role</label>
              <select name="role" defaultValue={existing?.role || 'Technician'}>
                {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div className="field">
              <label>Accent Color</label>
              <select name="color" defaultValue={existing?.color || 'var(--cyan)'}>
                {COLORS.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
              </select>
            </div>
          </div>
          <div className="modal-foot">
            {isEdit && (
              <button
                type="button"
                className="btn btn-ghost"
                style={{ color: 'var(--rose)', marginRight: 'auto' }}
                onClick={handleDelete}
              >
                Delete
              </button>
            )}
            <button type="button" className="btn btn-ghost" onClick={closeModal}>Cancel</button>
            <button type="submit" className="btn btn-primary">{isEdit ? 'Save Changes' : 'Add Technician'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
